module.exports = __webpack_public_path__ + "static/media/projector.4f855e3a.svg";